module.exports = __webpack_public_path__ + "img/parrallel_5.043407a1.png";